import { v4 as uuidv4 } from "uuid";

import {
  LandholdingDetails,
  NewProjectJourneyState,
  NewProjectJourneyStep,
  ProjectAccessStepState,
  ProjectDetailsStepState,
  ProjectEntryState,
  ProjectRow,
} from "../../models";

export const emptyManualProjectRow = (): ProjectRow => ({
  key: uuidv4(),
  displayName: "",
  projectTypeUuid: null,
  standardUuid: null,
  vvbUuid: null,
  addressRegion: null,
  addressPostcode: null,
  latitude: null,
  longitude: null,
  gridReference: null,
  addressCountryCode: null,
  areaNetHa: null,
});

export const emptyLandholdingDetails = (): LandholdingDetails => ({
  name: "",
  reference: null,
  referenceId: "",
  region: "",
  latitude: null,
  longitude: null,
  gridReference: null,
  countryCode: null,
});

export const emptyManualEntryState = (): ProjectEntryState => ({
  rows: [emptyManualProjectRow()],
  landholding: emptyLandholdingDetails(),
});

export const emptyUploadEntryState = (): ProjectEntryState => ({
  rows: [],
  landholding: emptyLandholdingDetails(),
});

export const defaultProjectDetailsStepState = (): ProjectDetailsStepState => ({
  entryMethod: "manual",
  isLandholding: false,
  data: emptyManualEntryState(),
  validationErrors: [],
});

export const defaultProjectAccessStepState = (): ProjectAccessStepState => ({
  organisations: [],
  responsibleOwners: {},
});

// Keys are the GraphQL OrganisationType enum, so they can be handed straight to searchOrganisations
// and to getProjectBuilderAccessOptions.
export const NEW_PROJECT_ORGANISATION_TYPE_OPTIONS = [
  { key: "DEVELOPER", value: "Developer" },
  { key: "DEVELOPMENT_MANAGER", value: "Development Manager" },
  { key: "ASSET_MANAGER", value: "Asset Manager" },
];

// A host can run the journey over its own step list, so the first step is whatever it says it is.
export const defaultNewProjectJourneyState = (
  firstStep: NewProjectJourneyStep = NewProjectJourneyStep.DETAILS
): NewProjectJourneyState => ({
  currentStep: firstStep,
  inProgressStep: firstStep,
  details: defaultProjectDetailsStepState(),
  access: defaultProjectAccessStepState(),
  createdProjects: null,
  isSaveAttempted: false,
});
